import {
    loadAutoInsertTextBlocks,
    loadConsolidateAndResend,
    loadInvoiceRemarks,
    loadOrderNomenclatureGrid,
    loadPendingBatches,
    loadPhysicianIdentifiers,
    loadPreviousInvoicingBatches,
    loadReportTextBlocks,
} from './lib';

window.loadConsolidateAndResend = (): void => loadConsolidateAndResend();
window.loadPendingBatches = (): void => loadPendingBatches();
window.loadReportTextBlocks = (): void => loadReportTextBlocks();
window.loadPreviousInvoicingBatches = (): void => loadPreviousInvoicingBatches();
window.loadOrderNomenclatureGrid = function (uniquePrefix: string, getInvoiceInformation: Function): void {
    loadOrderNomenclatureGrid(uniquePrefix, getInvoiceInformation);
};

window.loadInvoiceRemarks = function (uniquePrefix: string): void {
    loadInvoiceRemarks(uniquePrefix);
};

window.loadIdentifiers = (physicianID: number, isEdit: boolean): void => loadPhysicianIdentifiers(physicianID, isEdit);
window.loadAutoInsertTextBlocks = (textBlocks: any[], onClick: Function, onCancel: Function): void => loadAutoInsertTextBlocks(textBlocks, onClick, onCancel);
